import { render, staticRenderFns } from "./KCatalog.vue?vue&type=template&id=1164e044&"
import script from "./KCatalog.vue?vue&type=script&lang=js&"
export * from "./KCatalog.vue?vue&type=script&lang=js&"
import style0 from "./KCatalog.vue?vue&type=style&index=0&id=1164e044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports